import LargeArrow from "@/assets/icons/large-arrow.svg?react";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import React, { FC } from "react";

interface Props {
  item: any;
  currentStep: number;
  index: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}

const StepItem: FC<Props> = ({ item, currentStep /* setCurrentStep */ }) => {
  const { id, index, label, label2 } = item;

  if (id === "SEPARATOR") {
    return (
      <div className="flex items-center justify-center">
        <LargeArrow />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-3">
      <div
        className={cn(
          "flex h-5 w-5 items-center justify-center rounded-full bg-[#F0F2F4]",
          index == currentStep && index !== 2 && "bg-[#615CB7]",
        )}
      >
        {index < currentStep || currentStep == 2 ? (
          <Check size={10} />
        ) : (
          <div className={cn("h-2 w-2 rounded-full bg-[#F0F2F4]")} />
        )}
      </div>
      <div className="flex flex-col">
        <p
          className={cn(
            "text-sm text-[#A0ACBA]",
            index == currentStep && "text-[#615CB7]",
          )}
        >
          {label}
        </p>
        <p
          className={cn(
            "text-sm text-[#A0ACBA]",
            index == currentStep && "text-[#615CB7]",
          )}
        >
          {label2}
        </p>
      </div>
    </div>
  );
};

export default StepItem;
